import { FieldPath, FieldValues, UseFormReturn } from 'react-hook-form';

export const setFieldArrayHanlder =
  <TFieldValues extends FieldValues>(form: UseFormReturn<TFieldValues>) =>
  (fieldName: string, values: ControlledType) => {
    form.unregister(fieldName as FieldPath<TFieldValues>);
    form.setValue(fieldName as FieldPath<TFieldValues>, values, {
      shouldValidate: false,
      shouldDirty: false,
      shouldTouch: false,
    });
  };
